import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90329d9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-heading" }, "Tuition Fees", -1))
const _hoisted_2 = {
  key: 1,
  class: "margin-top-10"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-heading" }, "Payment completed", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The payment has been carried out.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Please note that it might take a couple of days for your payment to be fully processed at the university. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " A receipt of your payment has been sent to your student email address. ", -1))
const _hoisted_7 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "margin-top-10"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-heading" }, "Payment failed", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " There was a problem processing your payment. The payment service returned the following error message: ", -1))
const _hoisted_11 = { class: "errorMsg" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" If you need support, please contact the Finance Division at ")
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "margin-top-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MirroringUserBanner = _resolveComponent("MirroringUserBanner")!
  const _component_BackToInvoicesButton = _resolveComponent("BackToInvoicesButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.isMirroringUser)
      ? (_openBlock(), _createBlock(_component_MirroringUserBanner, {
          key: 0,
          personalId: _ctx.personalId,
          personName: _ctx.personName,
          lucatId: _ctx.lucatId
        }, null, 8, ["personalId", "personName", "lucatId"]))
      : _createCommentVNode("", true),
    _hoisted_1,
    (_ctx.paymentResponse === 'OK')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.paymentResponse), 1),
          _createElementVNode("p", null, [
            _hoisted_12,
            _createElementVNode("a", { href: _ctx.mailToLink }, "tuitionfees@eken.lu.se", 8, _hoisted_13)
          ])
        ])),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_BackToInvoicesButton, {
        personalId: _ctx.personalId,
        personName: _ctx.personName,
        lucatId: _ctx.lucatId
      }, null, 8, ["personalId", "personName", "lucatId"])
    ])
  ], 64))
}